import React, { useState, useEffect } from "react";
import CurrentSheetsList from "./CurrentSheetsList";
import CompletedSheetsList from "./CompletedSheetsList";

export default function PrintingSheetsPanel() {
  const [activeTab, setActiveTab] = useState("current"); // current | completed

  return (
    <div className="card h-100">
      <div className="card-header d-flex gap-3">
        <button
          className={`btn btn-sm ${activeTab === "current" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setActiveTab("current")}
        >
          Текущие
        </button>

        <button
          className={`btn btn-sm ${activeTab === "completed" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setActiveTab("completed")}
        >
          Завершенные
        </button>
      </div>

      <div className="card-body overflow-auto">
        {activeTab === "current" && <CurrentSheetsList />}
        {activeTab === "completed" && <CompletedSheetsList />}
      </div>
    </div>
  );
}
